import type { JsonObject } from '@inf-monkeys-tech/monkeys';
import { createDesignCapabilityEntry, i18n, jsonSchema } from './entry';
const text = { type: 'string' };
export const CHOICE_PICKER_MODEL_SCHEMA: JsonObject = {
    type: 'object',
    additionalProperties: false,
    properties: {
      nodes: {
        type: 'array',
        items: {
          type: 'object',
          additionalProperties: false,
          properties: {
            id: text,
            label: text,
            labelKey: text,
            labelI18n: { type: 'object', additionalProperties: text },
            count: { type: 'integer', minimum: 0 },
            defaultSelected: { type: 'boolean' },
          },
          required: ['id', 'label'],
        },
      },
      total: { type: 'integer', minimum: 0 },
      selectedNodeId: text,
      initialSelectionId: text,
      showSelectedId: { type: 'boolean' },
      search: { type: 'object', additionalProperties: false, properties: { value: text }, required: ['value'] },
      placeholderKey: text,
      searchPlaceholderKey: text,
      countLabelKey: text,
      statLabelKey: text,
      emptyLabelKey: text,
      loadingLabelKey: text,
      searchMode: { enum: ['remote', 'local'] },
      searchDebounceMs: { type: 'integer', minimum: 0 },
      contextHint: {
        type: 'object',
        additionalProperties: false,
        properties: { selectedLabelKey: text, emptyLabelKey: text, icon: { enum: ['layers', 'building'] } },
        required: ['selectedLabelKey', 'emptyLabelKey', 'icon'],
      },
      pagination: {
        type: 'object',
        additionalProperties: false,
        properties: {
          hasMore: { type: 'boolean' },
          nextCursor: { type: ['string', 'null'] },
          loadingMore: { type: 'boolean' },
        },
        required: ['hasMore', 'nextCursor', 'loadingMore'],
      },
      declarativeModelProjection: {
        type: 'object',
        additionalProperties: false,
        properties: {
          kind: { const: 'navigator' },
          selectedStateId: text,
          initialSelection: {
            type: 'object',
            additionalProperties: false,
            properties: {
              strategy: { enum: ['default-or-first', 'selected-only', 'result-only'] },
              intentPort: { const: 'capability.choice-picker.select' },
              payloadField: { const: 'itemId' },
            },
            required: ['strategy', 'intentPort', 'payloadField'],
          },
        },
        required: ['kind', 'selectedStateId'],
      },
    },
    required: ['nodes', 'pagination'],
  };
export const CHOICE_PICKER_ENTRY = createDesignCapabilityEntry({
  version: '3', revision: 3, schemaRevision: 3,
  id: 'monkeys.design.choice-picker', rendererKey: 'monkeys.design.renderer.choice-picker',
  kind: 'view', category: 'navigation', labelKey: 'monkeys.design.capability.choicePicker.label',
  descriptionKey: 'monkeys.design.capability.choicePicker.description',
  authoringLabel: i18n('Choice picker', '选项选择器'),
  authoringDescription: i18n('Search and select a host-owned paginated collection.', '搜索并选择宿主提供的分页集合。'),
  inputPort: 'content', schemaRef: 'monkeys-design://choice-picker/model/v1', schemaDocument: jsonSchema('monkeys-design://choice-picker/model/v1', CHOICE_PICKER_MODEL_SCHEMA),
  slots: ['controls'], supportedPageTypes: ['page', 'view', 'workspace'], supportedSurfaces: ['page', 'view', 'workspace', 'overlay'],
  outputPorts: [
    ...(['search', 'select', 'load-more'] as const).map((action) => {
      const field = action === 'search' ? 'value' : action === 'select' ? 'itemId' : 'cursor';
      return { name: `capability.choice-picker.${action}`, schemaRef: `monkeys-design://choice-picker/${action}/v1`,
        schemaDocument: jsonSchema(`monkeys-design://choice-picker/${action}/v1`, { type: 'object', additionalProperties: false, required: [field], properties: { [field]: text } }),
        allowedCommandKinds: ['query-intent'] as const };
    }),
  ],
});
